import { ReactNode } from "react";
import { Chip } from "@mui/material";
// @ts-expect-error package doesn't have type file
import { TextToPhonetic } from "react-phonetic-transcription";
import { PhonemeKeyboardChip } from "shared/constants";
import { CustomTooltip } from "@web-applications/allinga-web-components";
import theme from "styles/theme";

interface PhoneticKeyProps {
  character: string;
  onClick: () => void;
  tooltip: ReactNode | string;
  selectedTabIndex?: number;
}

function PhoneticKey({
  character,
  onClick,
  tooltip,
  selectedTabIndex,
}: PhoneticKeyProps) {
  return (
    <CustomTooltip
      title={tooltip}
      placement="top"
      disableHoverListener={false}
      forceShow
      component="span"
    >
      <Chip
        onClick={onClick}
        sx={{
          backgroundColor: "white",
          borderRadius: "0px",
          border: `1px solid ${theme.palette.action.active}`,
          height: "40px",
          width: "40px",
          "&:hover": {
            backgroundColor: `${PhonemeKeyboardChip.Hover}`,
          },
          "&:focus": {
            backgroundColor: `${PhonemeKeyboardChip.Focused}`,
          },
          fontSize: "16px",
          fontWeight: 500,
          color: "action.active",
          p: 0,
          mr: "12px",
          mb: "12px",
          ".MuiChip-label": {
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
          },
        }}
        label={
          selectedTabIndex === 0 ? (
            <TextToPhonetic style={{ fontSize: "16px" }}>
              {character === " " ? "space" : character}
            </TextToPhonetic>
          ) : (
            <span style={{ fontSize: "16px" }}>
              {character === " " ? "space" : character}
            </span>
          )
        }
      />
    </CustomTooltip>
  );
}

export default PhoneticKey;
